import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const ScalesAndLinesIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props} viewBox="0 0 28 28">
        <path stroke="currentColor" strokeWidth="1" d="M10.5 20.5a2 2 0 1 1-2-2m2 2a2 2 0 0 0-2-2m2 2h14m-16-2v-14m16 16L21 17m3.5 3.5L21 24M8.5 4.5 12 8M8.5 4.5 5 8" fill="none" />
    </SvgIcon>
)

export default ScalesAndLinesIcon
